module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v("y the time Timothy Hamilton had found his missing editor, chewed him out for leaving the office and returned around eleven, he expected Dawn to have settled the problems of her transportation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, I see your car is gone. Did that all work out like I said?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could tell by her grim expression that plenty was still bothering her so he paused at her desk instead of proceeding to his office. “No?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. They towed the car all right. They just don’t have anything they can loan me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, rent a car.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I tried.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tim was getting perturbed. “And?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("“There are a couple of big conventions in the Nashville area right now and every car for miles ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("around has either been rented or is reserved. Nobody could help me on such short notice.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s ridiculous. Somebody has a car available.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s what I thought till I tried to find one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You called everybody in the book?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everybody. Even the guys that rent clunkers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t expect you to stoop "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" low.” The minute the words were out of his mouth he regretted them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh? Why not? It might be a step up from what I usually drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t mean that the way it sounded,” Tim said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled a face. “I know. I’ve just had a bad morning. Guess I’m a little cranky.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long will the repairs take? Did the garage say?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. They’ll get back to me with that, hopefully today, but it won’t be in time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In time for what?” His brow furrowed. “If you need a ride home I’m sure we can arrange something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s more than that,” Dawn said. “I volunteer for meals-on-wheels and it’s my turn to deliver.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. Two nights this week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh-oh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My sentiments, exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tim made a snap decision. “Okay. I’ll lend you one of my cars till you get yours back. I’d rather it be the BMW than the Ferrari, if you don’t mind.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("He was pleased to see a little smile starting. The woman was actually pretty, in a well-scrubbed sort ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("of way. Funny he hadn’t noticed that before. He’d always seen her as an efficient adjunct to his office but hadn’t really paid much attention to her as an individual until today. That was usually the way he liked to keep his business relationships, but in this instance he could see there was need for a little more personal connection.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’d do that? Lend me a car, I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Under the circumstances, yes,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn shook her head. “I appreciate your offer but I can’t accept.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, besides the fact that I’d be scared to death I might scratch your expensive car, I can’t very well show up driving anything like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn huffed. “Because I’d be embarrassed, for starters. And I’d be worried sick to use it for deliveries. Suppose I spilled gravy or something in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Embarrassed? Why would you be embarrassed to drive a perfectly good BMW?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because a car like that probably costs more than most of my clients earn in a whole year. Maybe more. I try to make them feel comfortable accepting help, not show them how the other half lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’m the other half?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He mulled over her statement and realized she had a valid point. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay what?”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll drive you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That wasn’t what I meant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. But I am the one who smashed your car so I figure I owe you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t have to do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Consider me a fellow volunteer, just helping out in a pinch.” Tim couldn’t believe she was still hesitating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell you what,” Dawn finally said. “I’ll make a few calls, see if maybe Pastor Abernathy or Amy are free to deliver tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Amy? You mean my sister? Why her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because she’s been doing some of the evening meal distribution, too. I thought you knew?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose she may have mentioned it.” Tim set his jaw. “Look. I happen to know she has a late meeting scheduled. Forget about arranging for a substitute. I’ll drive you. Period. In the meantime, do you want me to throw a little mud on the BMW so it won’t look too nice?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn could tell she was out of options so she capitulated. “I don’t think that will be necessary. I’ll explain when I hand over the meals.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m almost afraid to ask what you plan to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can hear it for yourself,” she told him with a smile. “I’ll want you to come inside with me and meet some of my favorites. They’re delightful people. I think you’ll be pleasantly surprised.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No more surprised than I am right now,” Tim said. “Why have you never talked about doing volunteer work?”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess it never came up,” she answered. “You and I don’t have many in-depth conversations.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, maybe we should have,” he said. “I’m impressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t tell you about it to make points.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Still, you did,” he said with a smile. “I should be in the office all afternoon, after my lunch with my mother, so let me know when you’re ready to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rest of Dawn’s day flew past in a blur and 5:00 p.m. arrived before she knew it. Normally, she looked forward to taking the meals to her regulars. This evening, however, she was decidedly uneasy. Not only was she faced with having Tim Hamilton acting as her chauffeur, she’d realized belatedly that he was going to have to drive her home, too. Hamilton Media was located in Davis Landing, in the high-rent district along the Cumberland River, while she lived in Hickory Mills, a place often referred to as the “wrong side of the tracks.” She didn’t relish having her hypercritical boss see her modest apartment, even from the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She considered phoning for a taxi, then changed her mind for fear of offending him. The door to Tim’s office stood ajar and she could hear him talking on the phone, so she waited till he’d ended his conversation before rapping on the door and easing it open a bit farther.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Hamilton?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("He had removed his jacket, loosened his pale ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("blue silk tie and rolled up his shirtsleeves, yet his wavy dark hair was perfectly combed and he still looked like a glossy ad for Armani suits or expensive Italian loafers.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn hesitated, then plunged ahead. “All that correspondence you wanted is stacked on my desk, waiting for your signature.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I—uh—I thought I’d go home now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is it that late already?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m afraid so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then we’d better get going.” He stood. “Where do you live?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hickory Mills. On Third Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then let’s go. Can’t keep hungry folks waiting for their dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I still feel bad about this. I wouldn’t agree to it except—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Except I murdered your car. Have you heard anything about its repair or am I going to have to pay for its funeral, instead?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Repair. Definitely repair,” Dawn said, smiling. “The garage called. They promised a price break and I told them to go ahead. I hope that was okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine. Very efficient, as usual.” He slung his jacket over one shoulder, then joined her at the door. “I was going to do a bit more work before I called it a day but I guess I can come in early tomorrow. Let’s go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Having to take two steps for each of his long strides, she was nearly running by the time they got ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("to the elevator. He reached out and held the door for her to pass.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks,” she said. “I’m glad you’re not in a hurry. I’d probably have to wear track shoes to keep up with you if you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were moving pretty fast this morning,” Tim countered. “I had to run down the stairs to catch you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good thing you have such long legs then, huh?” Dawn saw him eye her much shorter stature and discerned a touch of wry humor in his expression. “My legs are not too short,” she insisted. “They reach all the way to the ground, don’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tim chuckled. “That, they do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly, Dawn wished she’d kept her mouth shut instead of calling attention to herself. She wasn’t ashamed of her lithe figure or the feminine clothing she favored, she just hadn’t meant for her otherwise reserved boss to take special notice. There had been times, ever since she’d started working for him, that she’d secretly wished he’d at least acknowledge her as a living, breathing human being. Now that he had, however, she wasn’t so sure she liked it, especially since they were cooped up in a cramped elevator. Alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t be silly,")]), _vm._v(" her sensible side argued. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("There’s nothing wrong with taking an innocent elevator ride with a man, no matter how handsome and dashing he happens to be.")]), _vm._v(" And there was certainly nothing wrong with Tim Hamilton’s manners. He was every bit the perfect Southern gentleman he’d always been.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Particularly in regard to other women,")]), _vm._v(" she added contritely. Until today, his suave graciousness had seemed reserved for women he saw socially. Now that Dawn was the recipient of the Hamilton charm, she wasn’t sure how she ought to react. One thing was certain, however. This was going to be a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" long evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she could have been positive the whole unfolding sequence of events was God’s idea, maybe meant to show Tim how to appreciate the simple things in life more, she’d have been happier with the situation. Then again, who was she to question her Heavenly Father?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The same silly person I’ve always been,")]), _vm._v(" she answered honestly. Some things were just beyond human comprehension and the only times she got herself into real trouble were when she tried to second-guess the Lord and help Him out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That ridiculous thought made her smile. As if God wasn’t capable of doing anything He wanted whether she cooperated or not!")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they reached the ground floor, Herman Gordon hailed them. “Night, Mr. Tim, Miss Dawn.” He bent to retrieve a picnic basket from beneath the counter that he and his wife, Louise, considered their private bailiwick. “Here’s the stuff you ordered from Betty’s, sir. It was just delivered a few minutes ago. Miss Justine brought it over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tim took the basket from him. “Thanks, Herman. Have a good evening.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man waved a clipboard. “Gotta sign out. Them’s the rules.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do it for us,” Tim called back, hurrying Dawn toward the door. “You know who we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn snickered quietly. “He’s a stickler, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wouldn’t have it any other way,” Tim said. “I just figured we’d better make tracks or he’d start telling us one of his long stories and you’d never get your meals delivered.” He led the way to his car. “Speaking of which, I thought we might be hungry, too, so I ordered a little dinner to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s what’s in the basket?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh-huh.” He opened the passenger door and held it for her. “I knew it wouldn’t be right to eat anything meant for delivery to your customers, so I planned ahead and ordered this when I had lunch at Betty’s today. I hope you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Not at all.” He handed her the basket, closed her door and laid his suit coat neatly across the backseat before finally getting behind the wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unsure of what he wanted her to do with the food, Dawn merely sat there on the smooth leather seat and held the basket on her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, aren’t you hungry?” Tim asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, but…you don’t intend for us to eat in the car, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because. What if we spill something?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you a messy eater?” There was evident humor in his tone.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not usually.” She had to smile. “However, when I’m trying to keep from making a mess, it’s much harder not to. Murphy’s law, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then it’s a good thing I didn’t order spaghetti,” Tim said, laughing softly. “There are supposed to be three kinds of sandwiches in there, a couple of pickles and some cold bottles of sparkling water with lemon. Anything else was Betty’s idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Three")]), _vm._v(" kinds of sandwiches?” Dawn lifted the lid and peeked into the basket. “You must be really hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t sure what you liked and I wanted to cover all the bases, that’s all. We can eat what we want and toss the rest in the garbage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not on your life! Where I come from we don’t waste food.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tim started the car and pulled out onto Main Street. “Where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" you come from? I didn’t notice that part of your personnel file when I reviewed it for your promotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It struck Dawn as odd that anyone would choose to read a file for background information rather than talk to the person involved. But that was typical Tim Hamilton, wasn’t it? Typical, but sad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My family’s from Louisiana, down by New Orleans.” She decided to elaborate rather than have him think she was ashamed of her roots, which she wasn’t. “Dad worked on the docks. Mom used to clean houses to help out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you from a big family like mine?”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. There are just two of us. My brother, Phillipe, and me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see. So, what brought you to Tennessee?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“College. I got a wonderful scholarship to Central Tennessee University.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Really? That’s where my sister Melissa used to go to school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn nodded. “I never could have afforded CTU if it hadn’t been for the scholarship. I was going to become an English teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you didn’t finish? Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Phil, mostly. He had a terrible accident that left him paralyzed. Mom stays home now to take care of him and I do all I can to help them out. The medical bills were unbelievable. Still are. I wouldn’t be sitting here talking to you if it hadn’t been for all that. It’s why I needed a full-time job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re going to go back to school, aren’t you?” He sounded genuinely concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe. Probably. I haven’t decided.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“College is vital,” Tim said. “We were all upset when Melissa dropped out and took off.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s the baby of the family, isn’t she?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. In more ways than her age.” He changed the subject with a nod toward the basket. “Aren’t you going to eat something?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess I should, since you went to all this trouble. What would you like?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("“Considering the morning I had, I think I’d better keep both hands on the wheel, don’t you? Go ahead without me. I can grab a bite while ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("you’re getting your meals ready or whatever it is you need to do.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay.” Dawn lifted the hinged lid of the basket, took out the sandwich on top and bit into it. “Umm. Tuna. Delicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She chewed and swallowed, then said, “First, I have a few things I need to do at my apartment. You can eat while I’m changing into something more comfortable.” Her cheeks burned the moment she realized the possible salacious interpretation of her innocent remark. “I meant, you can eat while you wait for me in the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sidelong glance at her companion revealed a smile he was trying to subdue. Tim was laughing at her. Oh, not out loud because he was too polite, but he was laughing, all the same. She’d have to choose her words a lot more carefully in the future. Some English major she’d turned out to be! A few minutes alone with Timothy Hamilton and her normally quick wit had fled like a dry leaf in a Tennessee tornado. Although he’d earned the behind-the-scenes nickname, Typhoon Tim, because of his habit of approaching work with the speed of a whirlwind, this was one more reason the name fit. He’d certainly blown her away with his cordiality and innate charisma.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn sighed in self-disgust and concentrated on finishing the first half of her sandwich. As she’d decided earlier, this was going to be a very, very long evening.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They’d crossed the Cumberland via Mill Road and were approaching the downtown area of Hickory Mills when Tim broke into her contemplation with a question. “Are we getting close?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. My apartment is on Third, like I said, near the corner of Market.” She screwed the cap back on her bottle of water, then pointed. “You can turn here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blotting her mouth with a paper napkin she placed the picnic basket on the seat between them. “This is it. Park anywhere along the street. I won’t be long.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take your time,” Tim said pleasantly. “I’ll be right here, relaxing and enjoying my supper.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swung in parallel to the cracked curb, shut off the engine and got out to open the car door for her. By the time he’d circled the car, however, Dawn had already let herself out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped short, slipped his hands into his pockets and struck a nonchalant pose while he watched her disappear into the three-story brick building.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman was independent, that was for sure. Spunky. And she had the uncanny ability to make him laugh, something he did far too infrequently, especially lately.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She also had a depth of character he’d missed seeing until now. Although he disagreed with her decision to quit school, he understood why a person would do so in order to help his or her family.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("If he and Dawn Leroux had nothing else in ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("common they had that—a deep need to support and maintain the bonds of kinship. He certainly couldn’t fault her for that.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dawn climbed the three flights of stairs and unlocked the door to her apartment. “Beau? I’m home. Where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thump of the enormous brindle dog’s tail against the hardwood flooring echoed in the otherwise silent room. Dawn smiled as he rose, stretched and lumbered over to greet her. She was able to pat his broad head without reaching or bending. Phil had been fond of saying that a mastiff was a lazy man’s dog and Dawn had to agree. Not only was Beauregard so laid-back he rarely moved faster than a walk, he also remained quiet and calm in the face of almost anything, making him ideal for an apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She snickered to herself as she led the dog down the back stairs and released him into the small yard that backed up to an overgrown drainage ditch. Why should Beau get excited? There wasn’t much he couldn’t handle if he had to. His mere size generally precluded the necessity to act. No human or animal in its right mind would challenge a dog with a muscled body the size of a pony, jaws as strong as an alligator’s and a tongue as broad as her palm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Finished sniffing the grass and weeds, Beau returned to her as if they’d been together all his life. Dawn was thankful she’d been able to adopt him as a favor to her brother after Phil’s crippling accident. Their agreement had been for her to temporarily ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("care for the big dog but, although it remained unsaid, Dawn and Phil both knew Beau would never go back to Louisiana.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t bother to leash him as they climbed the stairs together. Beau loved three things. Human companionship, food and naps, pretty much in that order. Since she was his best buddy and they were headed in the direction of his food dish, there was no chance Beau would stray.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a matter of fact, he beat her to the door, pushed past her legs, headed straight for his dish and sat patiently waiting for his dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kibble rattled into the bowl as she poured from the bag of dog food before she gave him fresh drinking water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was crunching happily as she straightened and patted him on his broad, mottled-brown back. “Okay, baby, enjoy. I’ll be back as soon as I can. I promise. You be good while I’m gone, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His tail wagged faster in reply, though his nose remained buried in the food.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She laughed. “Good. Stay right there so you don’t accidentally get me dirty. I’m going to go change. I have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" been having a very good day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The foolishness of conversing with a dog struck Dawn funny. Old Beau might not be a very good conversationalist but he sure was easy to talk to, wasn’t he?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("It was just as well Beau wasn’t able to give sage advice, she reasoned as she proceeded to don jeans and a blue short-sleeved sweater and run a brush ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("through her hair. If she could think of any way to get out of spending the evening driving around with her persnickety boss, she’d send him packing in a heartbeat.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c376066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426885747_ch02.vue
// module id = 84
// module chunks = 0